import type { Store } from '@/types/store';
import { api } from './client';

export const getStoreByNumber = (storeId: string, signal?: AbortSignal) =>
  api.get<Store>(`/api/stores/num/${encodeURIComponent(storeId)}`, { signal });

export const getOpeningStores = (signal?: AbortSignal) =>
  api.get<Store[]>('/api/stores/opening-soon', { signal });
